/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type  function
*  @date  8/11/2013
*  @since  4.3.0
*
*  @param  jQueryel (jQuery element)
*  @return  n/a
*/

export default function new_map( jQueryel ) {
  
  // var
  var jQuerymarkers = jQueryel.find('.marker');

  var stylez = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "visibility": "on"
            }
        ]
    }
];
  
  
  // vars
  var args = {
    zoom    : 16,
    center    : new google.maps.LatLng(0, 0),
    mapTypeId  : google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    disableDefaultUI: true,
    zoomControl: true
  };
  
  
  // create map            
  var map = new google.maps.Map( jQueryel[0], args);

  var mapType = new google.maps.StyledMapType(stylez, {
    name: "Grayscale"
  });
  map.mapTypes.set('tehgrayz', mapType);
  map.setMapTypeId('tehgrayz');
  
  // add a markers reference
  map.markers = [];
  
  
  // add markers
  jQuerymarkers.each(function(){
    add_marker( jQuery(this), map );
  });
  
  
  // center map
  center_map( map );
  
  
  // return
  return map;
  
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type  function
*  @date  8/11/2013
*  @since  4.3.0
*
*  @param  jQuerymarker (jQuery element)
*  @param  map (Google Map object)
*  @return  n/a
*/

function add_marker( jQuerymarker, map ) {

  // var
  var latlng = new google.maps.LatLng( jQuerymarker.attr('data-lat'), jQuerymarker.attr('data-lng') );

  var image = {
    url: document.body.dataset.home + '/public/images/pointer.png',
    size: new google.maps.Size(17, 23),
    origin: new google.maps.Point(0,0),
    anchor: new google.maps.Point(8, 23)
  };

  // create marker
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    size: new google.maps.Size(17, 23),
    icon: image
  });

  // add to array
  map.markers.push( marker );

  // if marker contains HTML, add it to an infoWindow
  if( jQuerymarker.html() )
  {
    // create info window
    var infowindow = new google.maps.InfoWindow({
      content    : jQuerymarker.html()
    });

    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function() {

      infowindow.open( map, marker );

    });
  }

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type  function
*  @date  8/11/2013
*  @since  4.3.0
*
*  @param  map (Google Map object)
*  @return  n/a
*/

function center_map( map ) {

  // vars
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  jQuery.each( map.markers, function( i, marker ){

    var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

    bounds.extend( latlng );

  });

  // only 1 marker?
  if( map.markers.length == 1 ) {
    // set center of map
    map.setCenter( bounds.getCenter() );
    map.setZoom( 16 );
  } else {
    // fit to bounds
    map.fitBounds( bounds );
  }

}

(function($) {
  var map = null;
  $(document).ready(function(){
    $('.map').each(function(){
      // create map
      map = new_map( $(this) );
      // popup is shown and map is not visible
      google.maps.event.trigger(map, 'resize');
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/partial/map.js